/*
 * C Edu Ingredients (sections/c-edu-ingredients.liquid).
 * Desktop: chips filter the list, a row click swaps the detail card, the first
 * visible row auto-selects. Mobile (< 750px): the rows are an accordion, one
 * open at a time, the first N shown until "Show all" expands the list.
 */
(function () {
  if (customElements.get('c-edu-ingredients')) return;

  var mobile = window.matchMedia('(max-width: 749px)');

  class CEduIngredients extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.list = this.querySelector('.c-ing__list');
      if (!this.list) return;
      this.listWrap = this.querySelector('.c-ing__list-wrap');
      this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-filter]'));
      this.more = this.querySelector('.c-ing__more');
      this.rows = parseInt(this.dataset.mobileRows, 10) || 6;
      this.expanded = false;
      this.filter = 'all';

      // Order by the metaobject's `sort` field (entries without one keep their place).
      var items = Array.prototype.slice.call(this.list.children);
      items
        .map(function (el, i) {
          return { el: el, key: parseFloat(el.dataset.sort), i: i };
        })
        .sort(function (a, b) {
          var ka = isNaN(a.key) ? Infinity : a.key;
          var kb = isNaN(b.key) ? Infinity : b.key;
          return ka - kb || a.i - b.i;
        })
        .forEach(
          function (o) {
            this.list.appendChild(o.el);
          }.bind(this)
        );
      this.items = Array.prototype.slice.call(this.list.children);

      this.chips.forEach(
        function (chip) {
          chip.addEventListener('click', this.setFilter.bind(this, chip.dataset.filter));
        }.bind(this)
      );
      this.list.addEventListener('click', this.onRow.bind(this));
      if (this.more) this.more.addEventListener('click', this.showAll.bind(this));
      mobile.addEventListener('change', this.apply.bind(this));

      this.apply();
    }

    visible() {
      var f = this.filter;
      return this.items.filter(function (el) {
        return f === 'all' || (' ' + el.dataset.products + ' ').indexOf(' ' + f + ' ') > -1;
      });
    }

    setFilter(value) {
      this.filter = value;
      this.expanded = false;
      this.chips.forEach(function (c) {
        c.setAttribute('aria-pressed', c.dataset.filter === value ? 'true' : 'false');
      });
      this.apply();
    }

    apply() {
      var shown = this.visible();
      var isMobile = mobile.matches;
      var limit = this.rows;
      var expanded = this.expanded;
      this.items.forEach(function (el) {
        var idx = shown.indexOf(el);
        el.hidden = idx === -1;
        el.classList.toggle('is-collapsed', isMobile && !expanded && idx >= limit);
      });
      if (this.more) {
        this.more.hidden = !isMobile || expanded || shown.length <= limit;
        this.more.textContent = (this.more.dataset.label || '').replace('[count]', shown.length);
      }
      if (this.listWrap) this.listWrap.scrollTop = 0;
      this.select(shown[0] || null);
    }

    select(item, focus) {
      var self = this;
      this.items.forEach(function (el) {
        var on = el === item;
        el.classList.toggle('is-active', on);
        el.querySelector('.c-ing__row').setAttribute('aria-expanded', on ? 'true' : 'false');
        el.querySelector('.c-ing__panel').hidden = !on;
      });
      Array.prototype.forEach.call(this.querySelectorAll('.c-ing__detail'), function (d) {
        d.hidden = !item || d.dataset.id !== item.dataset.id;
      });
      this.current = item;
      if (focus && item && mobile.matches) {
        var top = item.getBoundingClientRect().top;
        if (top < 0) item.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }

    onRow(e) {
      var row = e.target.closest('.c-ing__row');
      if (!row) return;
      var item = row.closest('.c-ing__item');
      // Mobile accordion: tapping the open row closes it.
      if (mobile.matches && item === this.current) {
        this.select(null);
        return;
      }
      this.select(item, true);
    }

    showAll() {
      this.expanded = true;
      var current = this.current;
      this.apply();
      if (current && !current.hidden) this.select(current);
    }
  }

  customElements.define('c-edu-ingredients', CEduIngredients);
})();
